import { Typography } from '@mui/material';

import { Container, StepNumberContainer } from './styled';

import { ReactComponent as SuccessIcon } from 'src/assets/svg/TxSuccess.svg';
import { ReactComponent as FailIcon } from 'src/assets/svg/TxTrackingFail.svg';

type StepItemProps = {
  step: number;
  title: string;
  isCompleted: boolean;
  isCurrent: boolean;
  isFailed?: boolean;
};

export default function StepItem({ step, title, isCompleted, isCurrent, isFailed }: StepItemProps) {
  return (
    <Container data-is-current={isCurrent || isCompleted}>
      {isCompleted ? (
        <SuccessIcon />
      ) : isFailed ? (
        <FailIcon />
      ) : (
        <StepNumberContainer data-is-current={isCurrent}>
          <Typography variant="h10">{step}</Typography>
        </StepNumberContainer>
      )}
      <Typography variant="h8">{title}</Typography>
    </Container>
  );
}
